import * as React from 'react';
import {FormattedMessage} from 'react-intl';
import Search, {SearchInputType} from "../../components/custom/Search";


interface SearchInputProps {
    search: (filter: object) => any;
    form: any;
}

export const ActiveTypeOption = [
    {
        value: 1,
        label: <FormattedMessage id="app.active" defaultMessage={`Active`}/>,

    },
    {
        value: 0,
        label: <FormattedMessage id="app.inactive" defaultMessage={`Inactive`}/>,
    }
];

export const SortOption = [
    {
        value: 'createdDate',
        label: <FormattedMessage id="app.create_date" defaultMessage={`Create`}/>,
    },
    {
        value: 'startStreamTime',
        label: <FormattedMessage id="app.start_date" defaultMessage={`Start`}/>,

    }
];

const SearchConductorsComponent: React.FC<SearchInputProps> = props => {
    const {search} = props;

    const inputs = [
        {
            name: "query",
            label: <FormattedMessage id="app.title" defaultMessage={`Title`}/>,
            type: SearchInputType.TEXT,
            size: 6
        },
        {
            name: "conductor_order",
            label: <FormattedMessage id="app.sort" defaultMessage={`Sort`}/>,
            type: SearchInputType.SELECT,
            options: SortOption,
            size: 6
        },
        {
            name: "is_active",
            label: <FormattedMessage id="app.status" defaultMessage={`Status`}/>,
            type: SearchInputType.SELECT,
            options: ActiveTypeOption,
            size: 6
        },
        {
            name: "channel_id",
            label: <FormattedMessage id="app.channel" defaultMessage={`Channel`}/>,
            type: SearchInputType.CHANNEL,
            size: 6
        },
        // {
        //     name: "from_start_date",
        //     label: <FormattedMessage id="app.from" defaultMessage={`From`}/>,
        //     type: SearchInputType.DATE,
        //     size: 12
        // },
        // {
        //     name: "to_start_date",
        //     label: <FormattedMessage id="app.to" defaultMessage={`To`}/>,
        //     type: SearchInputType.DATE,
        //     size: 12
        // }
    ];

    return <Search inputs={inputs} search={search}/>

};

export default SearchConductorsComponent;
